// extracted by mini-css-extract-plugin
module.exports = {"expand":"Areas_expand__3M5WL","value":"Areas_value__v5wEf"};